import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';
import { CheckDeliveryPriceModel, PurchaseOrderModel, ResponseCheckDeliveryPrice } from '../models/purchase-order-model';
import { LinesModel, PartCodesModel, TempRecorderModel } from '../models/lines-model';
import { StatusModel } from '../models/status-model';
import { map } from 'rxjs/operators';
import { DeliveryInstructionsModel } from '../models/delivery-instructions-model';
import { AdjusmentDTO } from '../models/validate-so-model';
import { DiscrepancySearchDTO } from '../../inquiries/models/sale-order-search-model';

@Injectable({
    providedIn: 'root'
})
export class PurchaseOrdersService {

    /**
     * URL to PO search
     */
    API_PO_LIST_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/list';
     API_PO_DISCREPANCY_LIST_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/getDiscrepancies';
      API_PO_ORDER_LIST_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/getOrderToCopy';
    API_LAST_PO_NUMBER_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/getLastPurchaseOrdersDummy';
     API_PO_DISCREPANCY_RREPORT_LIST_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/getDiscrepanciesReport';
     API_RESOLVE_DISCREPANCY_URL = environment.ipserver + 'o2c-backend/private/saleOrder/closeDiscrepancy';

    /**
     * URL to generate the PO PDF
     */
    API_GENERATE_PO_PDF_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/generate';

    /**
     * URL to PO's history
     */
    API_PO_HISTORY_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/poHistory';
     API_PO_HISTORY_WD_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/poHistoryWithDelete';

    /**
     * URL to shipping address
     */
    API_SHIPPING_ADDRESS_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/shippingAddress';

    /**
     * URL to PO lines
     */
    API_PO_LINES_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/lines';
    API_REFERENCE_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/getReference';
    API_LOT_NUMBERS_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/getLotNumbers';
    API_CONTAINER_NUMBERS_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/getContainersNumbers';


    /**
     * URL to contact price
     */
    API_CONTRACT_PRICE_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/contractPrice';

    /**
     * URL to validate lot number
     */
    API_VALIDATE_LOT_NUMBER_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/validateLotNumber';

    /**
     * URL to register new order for PO
     */
    API_REGISTER_ORDERS_URL = environment.ipserver + 'o2c-backend/private/saleOrder/register';
    API_REGISTER_ORDERS_WO_URL = environment.ipserver + 'o2c-backend/private/saleOrder/registerWO';
   
    /**
     * URL to Change order status for Locked sales order
     */
    API_CHANGE_STATUS_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/changeOrderStatus';
     API_CHANGE_STATUS_BY_ID_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/changeOrderStatusById';
     API_CHANGE_STATUS_SIMPLE_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/changeOrderStatusSimple';
     API_GENERATE_PO_CONFIRMATION_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/generatePoConfirmation';
    API_CHANGE_PO_RECONCILIED = environment.ipserver + 'o2c-backend/private/purchaseOrder/updatePOReconciled'
    API_DOWNLOAD_PO_CONFIRMATION_URL = environment.ipserver + 'o2c-backend/private/asn/getXMLPOConfirmation';
    API_DOWNLOAD_iTRADE_PO_CONFIRMATION_URL = environment.ipserver + 'o2c-backend/private/ediPO/getFFPOConfirmation';
    API_DOWNLOAD_iTRADE_ASN_URL = environment.ipserver + 'o2c-backend/private/ediPO/getFFASN';
     API_DOWNLOAD_ASN_URL = environment.ipserver + 'o2c-backend/private/asn/getXMLASN';
     API_DOWNLOAD_INVOICE_URL = environment.ipserver + 'o2c-backend/private/invoices/getXMLInvoice';
    /**
     * URL to get temp recorder part codes
     */
    API_TEMP_RECORDERS_PART_CODES_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/tempRecorderPartCodes';

	/**
     * URL to get temp recorder part information (partcode and promo indicator)
     */
	 API_TEMP_RECORDER_PART_INFORMATION_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/tempRecorderInformation';

    /**
     * URL to get status list
     */
    API_STATUS_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/status';

    /**
     * URL to get status list
     */
    API_SEARCH_PO_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/search';

    /**
     * URL to get status list
     */
    API_DELIVERY_INSTRUCTIONS_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/deliveryInstructions';
    /**
     * URL to get status list
     */
    API_PO_BY_CUSTOMER_UNPROCESSED_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/poNumbers';
    /**
     * URL to get detail report
     */
    API_PO_DETAIL_REPORT_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/detailReport';
    /**
     * URL to get a PO by its ID
     */
    API_FIND_PO_BY_ID_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/findPOById';
    /**
     * PO Check Delivery Price
     */
    API_PO_CHECK_DELIVERY_PRICE_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/checkDeliveryPrice';


	API_WEIGHT_URL = environment.ipserver + 'o2c-backend/private/saleOrder/getPartWeight';
	API_MAX_WEIGHT_URL = environment.ipserver + 'o2c-backend/private/saleOrder/getMaxWeight';
	API_DATE_PRICE_URL = environment.ipserver + 'o2c-backend/private/saleOrder/getSalesPriceInDateRange';
	API_SALES_PRICE_URL = environment.ipserver + 'o2c-backend/private/saleOrder/getSalesPrice';
	API_HAS_CONTRACT_QTY_OUTSTANDING_URL = environment.ipserver + 'o2c-backend/private/saleOrder/hasContractQtyOutstanding';
    API_ADJUSMENT_URL = environment.ipserver + 'o2c-backend/private/saleOrder/listAdjusment';
    API_SEARCH_PO_BY_DIVISON_AND_PO_NUMBER_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/getByDivisionAndPoNumber';
    /**
     * URL to check if PO is allowed to change with locked sales order
     */
    API_PO_CHANGE_WITH_LOCKED_SALES_ORDER_URL = environment.ipserver + 'o2c-backend/private/purchaseOrder/poChangeWithLockedSalesOrder';

    constructor( private httpC: HttpClient ) { }

    /**
     * Get the service response for search
     * @param customerNumber Customer number
     * @param receivedStartDate start date
     * @param receivedEndDate end date
     * @param deliveryStartDate start date
     * @param deliveryEndDate end date
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-13
     */
    public getPOList(
        customerNumber: string,
        receivedStartDate: string,
        receivedEndDate: string,
        deliveryStartDate: string,
        deliveryEndDate: string,
		includeProcessed: string
    ): Observable<PurchaseOrderModel[]> {
        const paramsForReq = new HttpParams()
            .set('customerNumber', String(customerNumber))
            .set('receivedStartDate', String(receivedStartDate))
            .set('receivedEndDate', String(receivedEndDate))
            .set('deliveryStartDate', deliveryStartDate)
			.set('includeProcessed', includeProcessed)
            .set('deliveryEndDate', deliveryEndDate);
        return this.httpC.get<PurchaseOrderModel[]>(this.API_PO_LIST_URL, { params: paramsForReq });
    }

    public getDiscrepancyList(
        customerNumber: string
       
    ): Observable<PurchaseOrderModel[]> {
        const paramsForReq = new HttpParams()
            .set('customerNumber', String(customerNumber))
            ;
        return this.httpC.get<PurchaseOrderModel[]>(this.API_PO_DISCREPANCY_LIST_URL, { params: paramsForReq });
    }

  
     public getDiscrepancyReportList(search: DiscrepancySearchDTO): Observable<any> {
    
            return this.httpC.post<any>(this.API_PO_DISCREPANCY_RREPORT_LIST_URL, search);
        }

     public getOrderToCopy(
        customerNumber: string,
        orderNumber: string,
        division: string       
    ): Observable<PurchaseOrderModel[]> {
        const paramsForReq = new HttpParams()
            .set('customerNumber', String(customerNumber))
            .set('orderNumber', String(orderNumber))
             .set('division', String(division))
            ;
        return this.httpC.get<PurchaseOrderModel[]>(this.API_PO_ORDER_LIST_URL, { params: paramsForReq });
    }

       public getLastPurchaseOrdersDummy(
        customerNumber: string,
        prefix: string       
    ): Observable<string[]> {
        const paramsForReq = new HttpParams()
            .set('customer', String(customerNumber))
            .set('prefix', String(prefix))
            ;
        return this.httpC.get<string[]>(this.API_LAST_PO_NUMBER_URL, { params: paramsForReq });
    }
    /**
     * Obtain a pdf for the po
     * @param id id from the po
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-15
     */
    generatePDFPO(id: string) {
        const paramsForReq = new HttpParams()
            .set('id', id);
        const type = 'text' as 'json';
        return this.httpC.get(this.API_GENERATE_PO_PDF_URL, { params: paramsForReq, responseType: type });
    }

    /**
     * Obtain a history of changes for the PO selected
     * @param customerNumber customer number
     * @param poNumber PO number
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-17
     */
    getPOHistory(customerNumber: string, poNumber: string): Observable<PurchaseOrderModel[]> {
        const paramsForReq = new HttpParams()
            .set('customerNumber', customerNumber)
            .set('poNumber', poNumber);
        return this.httpC.get<PurchaseOrderModel[]>(this.API_PO_HISTORY_URL, { params: paramsForReq });
    }

     getPOHistoryWD(customerNumber: string, poNumber: string): Observable<PurchaseOrderModel[]> {
        const paramsForReq = new HttpParams()
            .set('customerNumber', customerNumber)
            .set('poNumber', poNumber);
        return this.httpC.get<PurchaseOrderModel[]>(this.API_PO_HISTORY_WD_URL, { params: paramsForReq });
    }

    /**
     * Obtain shipping address for the PO selected
     * @param poID PO ID
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-24
     */
    getShippingAddress(poID: string): Observable<string[]> {
        const paramsForReq = new HttpParams()
            .set('poID', poID);
        return this.httpC.get<string[]>(this.API_SHIPPING_ADDRESS_URL, { params: paramsForReq });
    }

    /**
     * Obtain PO Lines related with the PO
     * @param poID PO ID
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-27
     */
    getPOLines(poID: string, customerNumber: string): Observable<LinesModel> {
        const paramsForReq = new HttpParams()
            .set('customerNumber', customerNumber)
            .set('poID', poID);
        return this.httpC.get<LinesModel>(this.API_PO_LINES_URL, { params: paramsForReq });
    }

    getReference( customerNumber: string): Observable<string[]> {
        const paramsForReq = new HttpParams()
            .set('customer', customerNumber);
        return this.httpC.get<string[]>(this.API_REFERENCE_URL, { params: paramsForReq });
    }

    getLotNumbers(warehouse: string, partCode: string): Observable<string[]> {
        const paramsForReq = new HttpParams()
        .set('warehouse', warehouse)
            .set('partCode', partCode);
        return this.httpC.get<string[]>(this.API_LOT_NUMBERS_URL, { params: paramsForReq });
    }

      getContainerNumbers(): Observable<string[]> {
        const paramsForReq = new HttpParams();
        return this.httpC.get<string[]>(this.API_CONTAINER_NUMBERS_URL, { params: paramsForReq });
    }

    /**
     * Obtain the contract price if the PO line basedOn is contract
     * @param customerNumber PO's customer number
     * @param partCode PO's part code
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-27
     */
    getContractPrice(customerNumber: string, partCode: string) {
        const paramsForReq = new HttpParams()
            .set('customerNumber', customerNumber)
            .set('partCode', partCode);
        return this.httpC.get(this.API_CONTRACT_PRICE_URL, { params: paramsForReq });
    }

    /**
     * Obtain a true if the lot number exist in Ross or an error message if not
     * @param warehouse PO's warehouse selected in header
     * @param partCode PO's part code
     * @param icLotNumber PO's lot number
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-27
     */
    getValidateLotNumber(warehouse: string, partCode: string, icLotNumber: string): Observable<string> {
        const paramsForReq = new HttpParams()
            .set('warehouse', warehouse)
            .set('partCode', partCode)
            .set('icLotNumber', icLotNumber);
        const type = 'text' as 'json';
        return this.httpC.get<string>(this.API_VALIDATE_LOT_NUMBER_URL, { params: paramsForReq, responseType: type });
    }

    /**
     * Post to register a new order from a PO
     * @param formValues object with all the info
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-29
     */
    postRegisterOrders(formValues: any): Observable<string> {
        const type = 'text' as 'json';
        return this.httpC.post<string>(this.API_REGISTER_ORDERS_URL, formValues, { responseType: type });
    }
    postRegisterOrdersWO(formValues: any): Observable<string> {
        const type = 'text' as 'json';
        return this.httpC.post<string>(this.API_REGISTER_ORDERS_WO_URL, formValues, { responseType: type });
    }
     

      public getAdjusmentList(): Observable<AdjusmentDTO[]> {
            return this.httpC.get<AdjusmentDTO[]>(this.API_ADJUSMENT_URL);
        }

    /**
     * Change order status for Locked sales order
     * @param newStatus Status to set (' ', 'P', 'C')
     * @param poNumber PO number
     * @param customerNumber Customer number
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-10-21
     */
    changeOrderStatus(newStatus: string, poNumber: string, customerNumber: string): Observable<boolean> {
        const paramsForReq = new HttpParams()
            .set('newStatus', newStatus)
            .set('poNumber', poNumber)
            .set('customerNumber', customerNumber);
        const type = 'text' as 'json';
        return this.httpC.put<boolean>(this.API_CHANGE_STATUS_URL, '', { params: paramsForReq, responseType: type })
            .pipe(
                map((auth) => {
                    if (typeof auth === 'string') {
                        auth = JSON.parse(auth);
                    }
                    return auth;
                })
            );
    }

    changeOrderStatusSimple(newStatus: string, poId: string, customerNumber: string): Observable<boolean> {
        const paramsForReq = new HttpParams()
            .set('newStatus', newStatus)
            .set('poId', poId)
            .set('customerNumber', customerNumber);
        const type = 'text' as 'json';
        return this.httpC.put<boolean>(this.API_CHANGE_STATUS_SIMPLE_URL, '', { params: paramsForReq, responseType: type })
            .pipe(
                map((auth) => {
                    if (typeof auth === 'string') {
                        auth = JSON.parse(auth);
                    }
                    return auth;
                })
            );
    }

        changeOrderStatusById(newStatus: string, poId: number, customerNumber: string): Observable<boolean> {
        const paramsForReq = new HttpParams()
            .set('newStatus', newStatus)
            .set('poId', poId)
            .set('customerNumber', customerNumber);
        const type = 'text' as 'json';
        return this.httpC.put<boolean>(this.API_CHANGE_STATUS_BY_ID_URL, '', { params: paramsForReq, responseType: type })
            .pipe(
                map((auth) => {
                    if (typeof auth === 'string') {
                        auth = JSON.parse(auth);
                    }
                    return auth;
                })
            );
    }

        generatePoConfirmation( poNumber: string,poId: number, customerNumber: string): Observable<boolean> {
        const paramsForReq = new HttpParams()
            .set('poId', poId)
            .set('poNumber', poNumber)
            .set('customerNumber', customerNumber);
        const type = 'text' as 'json';
        return this.httpC.post<boolean>(this.API_GENERATE_PO_CONFIRMATION_URL, '', { params: paramsForReq, responseType: type })
            .pipe(
                map((auth) => {
                    if (typeof auth === 'string') {
                        auth = JSON.parse(auth);
                    }
                    return auth;
                })
            );
    }
          downloadSPSPoConfirmation(poNumber: string): Observable<any> {
        const paramsForReq = new HttpParams()
            .set('poNumber', poNumber);
        const type = 'text' as 'json';
        return this.httpC.post<any>(this.API_DOWNLOAD_PO_CONFIRMATION_URL, '', { params: paramsForReq, responseType: type })
            .pipe(
                map((auth) => {
                    if (typeof auth === 'string') {
                        auth = JSON.parse(auth);
                    }
                    return auth;
                })
            );
    }
         downloadiTradePoConfirmation(poNumber: string): Observable<any> {
        const paramsForReq = new HttpParams()
            .set('poNumber', poNumber);
        const type = 'text' as 'json';
        return this.httpC.post<any>(this.API_DOWNLOAD_iTRADE_PO_CONFIRMATION_URL, '', { params: paramsForReq, responseType: type })
            .pipe(
                map((auth) => {
                    if (typeof auth === 'string') {
                        auth = JSON.parse(auth);
                    }
                    return auth;
                })
            );
    }

         downloadSPSASN(poNumber: string): Observable<any> {
        const paramsForReq = new HttpParams()
            .set('poNumber', poNumber);
        const type = 'text' as 'json';
        return this.httpC.post<any>(this.API_DOWNLOAD_ASN_URL, '', { params: paramsForReq, responseType: type })
            .pipe(
                map((auth) => {
                    if (typeof auth === 'string') {
                        auth = JSON.parse(auth);
                    }
                    return auth;
                })
            );
    }

         downloadiTradeASN(poNumber: string): Observable<any> {
        const paramsForReq = new HttpParams()
            .set('poNumber', poNumber);
        const type = 'text' as 'json';
        return this.httpC.post<any>(this.API_DOWNLOAD_iTRADE_ASN_URL, '', { params: paramsForReq, responseType: type })
            .pipe(
                map((auth) => {
                    if (typeof auth === 'string') {
                        auth = JSON.parse(auth);
                    }
                    return auth;
                })
            );
    }

        downloadSPSInvoice(orderNumber: string): Observable<any> {
        const paramsForReq = new HttpParams()
            .set('orderNumber', orderNumber);
        const type = 'text' as 'json';
        return this.httpC.post<any>(this.API_DOWNLOAD_INVOICE_URL, '', { params: paramsForReq, responseType: type })
            .pipe(
                map((auth) => {
                    if (typeof auth === 'string') {
                        auth = JSON.parse(auth);
                    }
                    return auth;
                })
            );
    }

    /**
     * Obtain part codes for temp recorders
     * @param warehouse warehouse
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-10-21
     */
    getTempRecorderPartCodes(warehouse: string): Observable<PartCodesModel[]> {
        const paramsForReq = new HttpParams()
            .set('warehouse', warehouse);
        return this.httpC.get<PartCodesModel[]>(this.API_TEMP_RECORDERS_PART_CODES_URL, { params: paramsForReq });
    }

	/**
     * Obtain temp recorder parts information (partcode and promo indicator for customer address)
     * @param division division
	 * @param customerNumber customerNumber
	 * @param addressCode addressCode
	 * @param warehouse warehouse
     * @author Castor Transformaci?n Digital - Andr?s Montilla
     * @since 2022-07-22
     */
	 getTempRecorderPartsInformation(division:string, customerNumber:string, addressCode:string, warehouse: string): Observable<TempRecorderModel> {
        const paramsForReq = new HttpParams()
			.set('division',division)
			.set('customerNumber',customerNumber)
			.set('addressCode',addressCode)
            .set('warehouse', warehouse);
        return this.httpC.get<TempRecorderModel>(this.API_TEMP_RECORDER_PART_INFORMATION_URL, { params: paramsForReq });
    }

    /**
     * Obtain a list of possible status for a purchase order
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-11-18
     */
    getStatusList(): Observable<StatusModel[]> {
        return this.httpC.get<StatusModel[]>(this.API_STATUS_URL);
    }

    /**
     * Get the search for EDI PO
     * @param customerNumber customer number
     * @param poNumber po number
     * @param status status (' ', 'P', 'C')
     * @param receivedStartDate Received date
     * @param receivedEndDate received date
     * @param processingStartDate processing date
     * @param processingEndDate processing date
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-11-10
     */
    getSearchPO(
        customerNumber: string,
        poNumber: string,
        status: string,
        receivedStartDate: string,
        receivedEndDate: string,
        startDeliveryDate: string,
        endDeliveryDate: string,
        processingStartDate: string,
        processingEndDate: string
    ): Observable<PurchaseOrderModel[]> {
        const paramsForReq = new HttpParams()
            .set('poNumber', poNumber)
            .set('customerNumber', customerNumber)
            .set('poStatus', status)
            .set('startReceivedDate', receivedStartDate)
            .set('endReceivedDate', receivedEndDate)
            .set('startDeliveryDate', startDeliveryDate)
            .set('endDeliveryDate', endDeliveryDate)
            .set('startProcessingDate', processingStartDate)
            .set('endProcessingDate', processingEndDate);
        return this.httpC.get<PurchaseOrderModel[]>(this.API_SEARCH_PO_URL, { params: paramsForReq });
    }

    /**
     * Get the search for EDI PO
     * @param customerNumber customer number
     * @param poNumber po number
     * @param status status (' ', 'P', 'C')
     * @param receivedStartDate Received date
     * @param receivedEndDate received date
     * @param processingStartDate processing date
     * @param processingEndDate processing date
     * @param division Division number
     * @param addressCode Address code number
     * @author Castor Transformaci?n Digital - Fabio Oquendo
     * @since 2021-01-12
     */
    getSearchPODetailReport(
        customerNumber: string,
        poNumber: string,
        status: string,
        receivedStartDate: string,
        receivedEndDate: string,
        startDeliveryDate: string,
        endDeliveryDate: string,
        processingStartDate: string,
        processingEndDate: string,
        division: string,
        addressCode: string,
        hasTempRecorder: boolean
    ): Observable<PurchaseOrderModel[]> {
        const paramsForReq = new HttpParams()
            .set('poNumber', poNumber)
            .set('customerNumber', customerNumber)
            .set('poStatus', status)
            .set('startReceivedDate', receivedStartDate)
            .set('endReceivedDate', receivedEndDate)
            .set('startDeliveryDate', startDeliveryDate)
            .set('endDeliveryDate', endDeliveryDate)
            .set('startProcessingDate', processingStartDate)
            .set('endProcessingDate', processingEndDate)
            .set('division', division)
            .set('addressCode', addressCode)
            .set('hasTempRecorder', String(hasTempRecorder));
        return this.httpC.get<PurchaseOrderModel[]>(this.API_PO_DETAIL_REPORT_URL, { params: paramsForReq });
    }

    /**
     * Get the delivery instructions according to addressCode
     * @param division division number
     * @param customerNumber customer number
     * @param addressCode address code
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-11-20
     */
    getDeliveryInstructions(division: string, customerNumber: string, addressCode: string): Observable<DeliveryInstructionsModel> {
        const paramsForReq = new HttpParams()
            .set('division', division)
            .set('customerNumber', customerNumber)
            .set('addressCode', addressCode);
        return this.httpC.get<DeliveryInstructionsModel>(this.API_DELIVERY_INSTRUCTIONS_URL, { params: paramsForReq });
    }

    /**
     * Obtain list of purchase orders
     * @param division division number
     * @param customerNumber customer number
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-11-20
     */
    getUnprocessedPOByCustomer(division: string, customerNumber: string, shipToId: string): Observable<PurchaseOrderModel[]> {
       if(shipToId != null){
		const paramsForReq = new HttpParams()
            .set('division', division)
            .set('customerNumber', customerNumber)
            .set('shipToId', shipToId);
        return this.httpC.get<PurchaseOrderModel[]>(this.API_PO_BY_CUSTOMER_UNPROCESSED_URL, { params: paramsForReq });

	   }
	   else
	   {
		return of([]);
	   }
 }

    /**
     * Obtain PO data for a given ID
     * @param poID PO ID
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2021-01-22
     */
    getPOByID(poID: string): Observable<PurchaseOrderModel> {
        const paramsForReq = new HttpParams()
            .set('poId', poID);
        return this.httpC.get<PurchaseOrderModel>(this.API_FIND_PO_BY_ID_URL, { params: paramsForReq });
    }

    /**
     * Obtain PO data for a given ID
     * @param poID PO ID
     * @author Castor Transformaci?n Digital - Alvaro Felipe Garcia Mendez
     * @since 2021-01-22
     */
     poCheckDeliveryPrice(checkData: CheckDeliveryPriceModel): Observable<ResponseCheckDeliveryPrice> {
        return this.httpC.post<ResponseCheckDeliveryPrice>(this.API_PO_CHECK_DELIVERY_PRICE_URL, checkData);
    }


	/**
     * Obtain a Weight for a partCode
     * @param partCode
     * @author Castor Transformaci?n Digital - Alejandro Segura
     * @since 2022-10-21
     */
	 getPartWeight(partCode: string) {
        const paramsForReq = new HttpParams()
            .set('partCode', partCode);
        const type = 'text' as 'json';
        return this.httpC.get(this.API_WEIGHT_URL, { params: paramsForReq, responseType: type });
    }

	/**
     * Obtain a MAX Order Weight
     * @author Castor Transformaci?n Digital - Alejandro Segura
     * @since 2022-10-21
     */
	 getMaxWeight() {
        const paramsForReq = new HttpParams();
        const type = 'text' as 'json';
        return this.httpC.get(this.API_MAX_WEIGHT_URL, { params: paramsForReq, responseType: type });
    }

	/**
     * Sales price in date range (getSalesPriceInDateRange): part, warehouse, customer, address, ship date.
     * @param partCode Product code
     * @param warehouse Warehouse code (required by backend)
     * @param date Ship date (ISO yyyy-MM-dd)
     * @param customer Customer number
     * @param address_code Ship-to / address code
     */
	 getDatePrice(
		partCode: string,
		warehouse: string,
		date: string,
		customer: string,
		address_code: string,
		priceOverride?: string,
		currentPrice?: string
	) {
        let paramsForReq = new HttpParams()
            .set('partCode', partCode)
			.set('warehouse', String(warehouse))
			.set('customer', customer)
			.set('address_code', address_code)
			.set('shipDate', date);
		if (priceOverride) {
			paramsForReq = paramsForReq.set('priceOverride', priceOverride);
		}
		if (currentPrice != null && currentPrice !== '') {
			paramsForReq = paramsForReq.set('currentPrice', String(currentPrice));
		}
        const type = 'text' as 'json';
        return this.httpC.get(this.API_DATE_PRICE_URL, { params: paramsForReq, responseType: type });
    }

	/**
     * Delivered (SOP) sales price for customer, part, ship-to, ship date and warehouse.
     * GET getSalesPrice ? query: customer, partCode, customerAddress, shipDate, warehouse.
     */
	 getSalesPrice(
		customer: string,
		partCode: string,
		customerAddress: string,
		date: string,
		warehouse: string,
		priceOverride?: string,
		currentPrice?: string
	) {
        let paramsForReq = new HttpParams()
            .set('partCode', partCode)
			.set('customer', customer)
			.set('customerAddress', customerAddress)
			.set('shipDate', date)
			.set('warehouse', String(warehouse));
		if (priceOverride) {
			paramsForReq = paramsForReq.set('priceOverride', priceOverride);
		}
		if (currentPrice != null && currentPrice !== '') {
			paramsForReq = paramsForReq.set('currentPrice', String(currentPrice));
		}
        const type = 'text' as 'json';
        return this.httpC.get(this.API_SALES_PRICE_URL, { params: paramsForReq, responseType: type });
    }

	/**
     * Whether contract quantity is still outstanding for the given sale order context.
     * GET hasContractQtyOutstanding — same query params as getSalesPrice plus quantity.
     */
	hasContractQtyOutstanding(
		customer: string,
		partCode: string,
		customerAddress: string,
		shipDate: string,
		warehouse: string,
		quantity: number
	): Observable<boolean> {
		const paramsForReq = new HttpParams()
			.set('partCode', partCode)
			.set('customer', customer)
			.set('customerAddress', customerAddress)
			.set('shipDate', shipDate)
			.set('warehouse', String(warehouse))
			.set('quantity', String(quantity));
		return this.httpC.get<boolean>(this.API_HAS_CONTRACT_QTY_OUTSTANDING_URL, { params: paramsForReq });
	}

    /**
     * Obtain a po number for a division and po number
     * @param division
     * @param poNumber
     * @author Castor Transformaci?n Digital - Ana Qui?ones
     * @since 2025-06-30
     */
    getPurchaseOrderByDivisionAndPoNumber(division: string, poNumber: string): Observable<PurchaseOrderModel> {
        const params = new HttpParams()
            .set('division', division)
            .set('poNumber', poNumber);
        return this.httpC.get<PurchaseOrderModel>(this.API_SEARCH_PO_BY_DIVISON_AND_PO_NUMBER_URL, { params });
    }

    /**
     * Check if the PO is allowed to change with locked sales order.
     * Returns non-empty array when the PO can be changed (unlock); empty array when it cannot.
     * @param poNumber PO number
     * @returns Observable of purchase order array (non-empty = allow change / unlock)
     */
    getPoChangeWithLockedSalesOrder(poNumber: string): Observable<PurchaseOrderModel[]> {
        const params = new HttpParams()
            .set('poNumber', String(poNumber));
        return this.httpC.get<PurchaseOrderModel[]>(this.API_PO_CHANGE_WITH_LOCKED_SALES_ORDER_URL, { params });
    }

    changePoReconciled(poNumber: string, customerNumber: string): Observable<any> {
        const params = new HttpParams()
          .set('poNumber', poNumber)
          .set('customerNumber', customerNumber);
      
        const responseType = 'text' as const;
      
        return this.httpC.put(this.API_CHANGE_PO_RECONCILIED, {}, {
          params,
          responseType,
          headers: new HttpHeaders().set('Content-Type', 'application/json')
        });
    }

    /**
     * Resolve a discrepancy
     * @param customer Customer number
     * @param orderNumber Order number
     * @param division Division
     * @param comment Comment for the resolution
     * @author Castor Transformaci?n Digital - AI Assistant
     * @since 2025-01-08
     */
    resolveDiscrepancy(user: string, orderNumber: string, division: string, comment: string): Observable<any> {
        const payload = {
            user: user,
            orderNumber: orderNumber,
            division: division,
            comment: comment
        };
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this.httpC.post<any>(this.API_RESOLVE_DISCREPANCY_URL, payload, { headers });
    }

    /**
     * Update a purchase order
     * @param purchaseOrder Purchase order to update
     * @author Castor Transformaci?n Digital - AI Assistant
     * @since 2025-01-08
     */
    updatePurchaseOrder(purchaseOrder: PurchaseOrderModel): Observable<boolean> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this.httpC.put<boolean>(this.API_PO_LIST_URL, purchaseOrder, { headers })
            .pipe(
                map((response) => {
                    if (typeof response === 'string') {
                        response = JSON.parse(response);
                    }
                    return response;
                })
            );
    }
      
      
}
